var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CheckDetails',{attrs:{"check":_vm.check},on:{"configure":function($event){_vm.configure = true}}}),_c('CheckForm',{attrs:{"appId":_vm.appId,"check":_vm.check},model:{value:(_vm.configure),callback:function ($$v) {_vm.configure=$$v},expression:"configure"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }